import React, { useState } from "react";
import { connect } from "react-redux";
import DatePicker from '@hassanmojab/react-modern-calendar-datepicker';
import '@hassanmojab/react-modern-calendar-datepicker/lib/DatePicker.css';
import '../../assets/styles/components/date-picker/date-picker.scss';
import { DATE_PICKER_TYPE } from "../../constants/app";
import closeIcon from '../../assets/images/icons/quote_icon_close.png'
import { Validators } from "../../helpers/functions";
import { getSafe } from "@/helpers/global";

class DatePickerCustomMobile extends React.Component {
  constructor(props) {
    super(props);
    props.innerRef(this);
    this.state = {
      initValue: null,
      inputPlaceholder: 'common_select_day',
      isReady: false,
      currentValue: null
    }
  }

  render() {
    const { language, type, style, maximumDate, minimumDate, readonly, id } = this.props;
    const { initValue, inputPlaceholder, isReady } = this.state;
    return (
        <div className='date-picker-custom-container' style={style}>
          {isReady && <DatePickerRender
              id={id}
              readonly={readonly} 
              maximumDate={maximumDate}
              minimumDate={minimumDate}
              type={type}
              initValue={initValue}
              inputPlaceholder={inputPlaceholder}
              onChange={this.handleChange}
              language={language}/>}
        </div>
    )
  }

  validateDateObject(date) {
    return date && date.year && date.month && date.day
  }

  setValue = (value) => {
    switch (this.props.type) {
      case DATE_PICKER_TYPE.SINGLE_DATE: {
        if (this.validateDateObject(value)) {
          this.setState({ initValue: value })
        }
        break;
      }
	  case DATE_PICKER_TYPE.BARTHDAY_DATE: {
	    if (this.validateDateObject(value)) {
	      this.setState({ initValue: value })
	    }
	    break;
	  }
      case DATE_PICKER_TYPE.MULTIPLE_DATE: {
        break;
      }
      case DATE_PICKER_TYPE.RANGE_DATE: {
        // const exampleData = {
        //     from: {
        //         year: 2020,
        //         month: 12,
        //         day: 20
        //     },
        //     to: {
        //         year: 2020,
        //         month: 12,
        //         day: 24
        //     }
        // }
        if (value && this.validateDateObject(value.from) && this.validateDateObject(value.to)) {
          this.setState({ initValue: value })
        }
        break;
      }
      default: {
        break;
      }
    }
  }

  getValue = () => {
    return this.state.currentValue;
  }

  handleChange = (e) => {
    this.setState({ currentValue: e })
    this.props.onChange(e);
  }

  componentDidMount() {
    switch (this.props.type) {
      case DATE_PICKER_TYPE.SINGLE_DATE: {
        if(this.validateDateObject(this.props.maximumDate)){
          this.setState({ initValue: this.props.maximumDate, inputPlaceholder: 'common_select_day', isReady: true })
        } else {
          this.setState({ initValue: null, inputPlaceholder: 'common_select_day', isReady: true })
        }
        break;
      }
	  case DATE_PICKER_TYPE.BARTHDAY_DATE: {
	    this.setState({ initValue: null, inputPlaceholder:"login_birthday_date", isReady: true })
	    break;
	  }
	  
      case DATE_PICKER_TYPE.MULTIPLE_DATE: {
        this.setState({ initValue: [], inputPlaceholder: 'Select days', isReady: true })
        break;
      }
      case DATE_PICKER_TYPE.RANGE_DATE: {
        this.setState({
          initValue: {
            from: null,
            to: null
          },
          inputPlaceholder: 'Select a day range',
          isReady: true
        })
        break;
      }
      default: {
        break;
      }
    }
  }
}

DatePickerCustomMobile.defaultProps = {
  type: DATE_PICKER_TYPE.SINGLE_DATE,
  onChange: () => {
  },
  innerRef: () => {
  },
  maximumDate: {},
  minimumDate: {}
}

export default connect(
    state => ({
      language: state.app.language
    })
)(DatePickerCustomMobile)

const DatePickerRender = (props) => {
  const [selectedDate, setSelectedDate] = useState(props.initValue)
  const [originalValue] = useState(props.initValue)
  const [textInput, setTextInput] = useState('')
  const [isDeletePress, setIsDeletePress] = useState(false)

  const formatInputText = () => {
    switch (props.type) {
      case DATE_PICKER_TYPE.SINGLE_DATE: {
        return selectedDate ? `${selectedDate.year}-${selectedDate.month}-${selectedDate.day}` : ''
      }
	  case DATE_PICKER_TYPE.BARTHDAY_DATE: {
	    return selectedDate ? `${selectedDate.year}/${selectedDate.month}/${selectedDate.day}` : ''
	  }
      case DATE_PICKER_TYPE.MULTIPLE_DATE: {
        return 'Do not supported';
      }
      case DATE_PICKER_TYPE.RANGE_DATE: {
        if (selectedDate.from && selectedDate.to) {
          const fromDate = `${selectedDate.from.year}/${selectedDate.from.month}/${selectedDate.from.day}`
          const toDate = `${selectedDate.to.year}/${selectedDate.to.month}/${selectedDate.to.day}`
          return `${fromDate} - ${toDate}`
        }
        return '';
      }
      default: {
        return '';
      }
    }
  };

  const handleKeyDown = e => {
    setIsDeletePress(e.keyCode === 8)
  }

  const autoCompleteDate = (value, separator = '/') => {
    if (value.length === 4) {
      value += separator
    } else if (value.length === 7 && (value.match(/\//g) || []).length === 1) {
      value += separator
    }

    if (/[0-9]{4}\/[0-9]{1,2}\/[0-9]{1,2}/.test(value)) {
      value = value.match(/[0-9]{4}\/[0-9]{1,2}\/[0-9]{1,2}/)[0];
    }
    return value
  }

  const validateDateInput = (value) => {
    switch (props.type) {
      case DATE_PICKER_TYPE.SINGLE_DATE: {
        if (/[0-9]{4}\/[0-9]{1,2}\/[0-9]{1,2}/.test(value)) {
          const dateParts = value.split('/');
          setSelectedDate({
            year: parseInt(dateParts[0]),
            month: parseInt(dateParts[1]),
            day: parseInt(dateParts[2])
          })
        }
        break;
      }
        // case DATE_PICKER_TYPE.RANGE_DATE: {
        //   const spaceLessText = value.replace(/\s/g, '');
        //   if (/[0-9]{4}\/[0-9]{1,2}\/[0-9]{1,2}-[0-9]{4}\/[0-9]{1,2}\/[0-9]{1,2}/.test(spaceLessText)) {

        //     const fromParts = spaceLessText.split('-')[0].split('/');
        //     const toParts = spaceLessText.split('-')[1].split('/');
        //     setSelectedDate({
        //       from: {
        //         year: parseInt(fromParts[0]),
        //         month: parseInt(fromParts[1]),
        //         day: parseInt(fromParts[2])
        //       },
        //       to: {
        //         year: parseInt(toParts[0]),
        //         month: parseInt(toParts[1]),
        //         day: parseInt(toParts[2])
        //       }
        //     })
        //   }
        //   break;
        // }
      default: {
        break;
      }
    }
  }

  const handleInput = e => {
    let value = e.target.value;
    if (isDeletePress) {
      setTextInput(value)
      validateDateInput(value)
    } else {
      if (value === '') {
        setTextInput(value)
      } else if (Validators.date(value, '/')) {
        value = autoCompleteDate(value);
        setTextInput(value)
        validateDateInput(value)
      }
    }
  }

  const renderCustomInput = ({ ref }) => (
      <div className='custom-input'>
        <input
           id={props.id}
            // readOnly
            ref={ref} // necessary
            readonly={props.readonly}
            placeholder={getSafe(() => props.language[props.inputPlaceholder], props.inputPlaceholder)}
            value={textInput}
            onChange={handleInput}
            onKeyDown={handleKeyDown}
            readOnly="readOnly"
        />
        {/* {textInput && <span onClick={() => setSelectedDate(props.initValue)}>
        <img src={closeIcon} alt="dialog_close_icon" />
      </span>} */}
      </div>

  )

  React.useEffect(() => {
    if (props.initValue !== originalValue) {
      setSelectedDate(props.initValue)
    }
  }, [props.initValue]);

  React.useEffect(() => {
    const text = formatInputText();
    setTextInput(text)
    if (text) {
      props.onChange(selectedDate)
    }
  }, [selectedDate]);

  return (
      <DatePicker
          value={selectedDate}
          onChange={setSelectedDate}
          renderInput={renderCustomInput}
          maximumDate={props.maximumDate}
          minimumDate={props.minimumDate}
          shouldHighlightWeekends
          calendarClassName="custom-calendar"
          calendarTodayClassName="custom-today-day"
          calendarSelectedDayClassName='custom-selected-day'
          calendarRangeStartClassName='custom-range-start'
          calendarRangeBetweenClassName='custom-range-between'
          calendarRangeEndClassName='custom-range-end'
      />
  );
};
